
import React, { Component } from 'react';
import './JWPlayer.css';

const NAMESPACE = '[ JWPlayer ]';

class JWPlayer extends Component {

	constructor(props){
		super(props);

		this.state = {
			player: null
		}
	}

	componentDidMount() {
		const { playerId, setup, onEvents } = this.props;

		if (window.jwplayer) {
			const jwplayer = window.jwplayer;
			const player = jwplayer(playerId).setup(setup);

			this.setState({player});

			for	(const evt in onEvents) {
				player.on(evt, onEvents[evt]);
			}
		}
	}
	
	render(){
		return(null);
	}
}

export default JWPlayer;


// WEBPACK FOOTER //
// ./src/package-reward-ads-overlay/components/JWPlayer.js